import {Pipe, PipeTransform} from '@angular/core';
import {AELTERE_VERSION, AKTUELL_VERSION, ALT_VERSION, NEXT_VERSION} from '../../../assets/static';

@Pipe({
    name: 'WbaAntragVersion',
    standalone: false
})
export class WbaAntragVersionPipe implements PipeTransform {

  private readonly FACHLICHER_ANTRAG_NAME_MAP = new Map([
    [`${AELTERE_VERSION}`, '0420'],
    [`${ALT_VERSION}`, '0821'],
    [`${AKTUELL_VERSION}`, '0822'],
    [`${NEXT_VERSION}`, '0823'],
  ]);

  transform(wbaAntragVersion: string): string {
    return this.FACHLICHER_ANTRAG_NAME_MAP.get(wbaAntragVersion);
  }

}
